import { defineStyle, defineStyleConfig } from '@chakra-ui/react'

const filled = defineStyle({
  background: '#DEDEDE',

  // let's also provide dark mode alternatives
  _dark: {
    borderColor: 'gray.600',
    background: 'gray.800',
  },
})

export const textareaTheme = defineStyleConfig({
  variants: { filled },
})